import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { Documents } from '../containers/Documents/Documents';
import { selectUserPermissions } from '../containers/Login/LoginSlice';
import { useAppSelector } from '../hooks';
import { useTenantNameSubtitle } from '../utils/customHooks/useTenantNameSubtitle';
import { BrowseFolderPage } from './browseFolder';

export const DocumentsPage = () => {
  const userPermissions = useAppSelector(selectUserPermissions);
  const [isOpen, setIsOpen] = useState(false);
  const tenantNameSubtitle = useTenantNameSubtitle();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout
            isMessageLayout
            message="documents"
            to="/dashboard"
            showBottomTabs
            subMessageText={tenantNameSubtitle}
            subMessageType="accent"
            showDots={userPermissions?.documents.mayManageOffline ?? false}
            dotsCallBack={() => setIsOpen(!isOpen)}
          >
            <Documents isHeaderOptionsOpen={isOpen} setHeaderOptionsOpen={setIsOpen} />
          </Layout>
        }
      />
      <Route path="/:groupDocumentId" element={<BrowseFolderPage />} />
      <Route path="/:groupDocumentId/:folderId" element={<BrowseFolderPage />} />
    </Routes>
  );
};
